import { IStyle } from '@fluentui/react';

export interface IChartStyles {
  root: IStyle;
}

export interface IChartClassNames {
  root: string;
}

export const chartStylesDefault: Partial<IChartStyles> = {
  root: {
    height: '100%',
  },
};
